import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid, Typography, units } from '@hbf/dsl';
import { LinkItemType } from '../types';
import { LinkItem } from './LinkItem';

export const useStyles = makeStyles()(theme => ({
  columnTitle: {
    textAlign: 'center',
    marginTop: units.rem(2),
    marginBottom: units.rem(0.2),

    [theme.breakpoints.up('sm')]: {
      marginTop: units.rem(0),
      textAlign: 'left',
    },
  },
}));

export interface Props {
  rel: string;
  title: string;
  links: LinkItemType[];
}

const LinkList: React.FC<Props> = ({ rel, title, links }) => {
  const { T, urlResolver } = useIntl();
  const { classes } = useStyles();

  return (
    <Grid item xs={1} data-test-locator={`Footer/${title}`}>
      <Typography.ParagraphTitle color="white" className={classes.columnTitle}>
        {T(title)}
      </Typography.ParagraphTitle>
      {links.map(({ name, urlBuilder, label, noFollow }) => (
        <LinkItem
          track={{ name }}
          link={{ to: urlResolver[urlBuilder](), rel: noFollow || rel }}
          label={label}
          key={label}
        />
      ))}
    </Grid>
  );
};

export { LinkList };
